// extracted by mini-css-extract-plugin
export var closeButton = "_ju-2";
export var closeButtonIcon = "_ju-3";
export var lightboxContent = "_ju-1";
export var lightboxOverlay = "_ju-0";